import React, { useState } from "react";
import classes from "./Login.module.css"
import { Link } from "react-router-dom";
import Button from "../../../Button/Button";


const Login = () => {

    const [activeSign, setActiveSign] = useState(true)

    return (
        <div className={classes.registrationWrapper}>
            <div className={classes.tabs}>
                <div onClick={()=>setActiveSign(true)} className={activeSign ? classes.loginTab + " " + classes.activeBtn : classes.loginTab}>Войти</div>
                <div onClick={()=>setActiveSign(false)} className={!activeSign ? classes.registrationTab + " " + classes.activeBtn : classes.registrationTab}>Регистрация</div>
            </div>
            {activeSign ? (
                <div className={classes.loginBox}>
                    <p style={{color: "#ba0000"}}><b>Регистрация на сайте временно НЕ РАБОТАЕТ</b></p>
                    <input type="text" name="1" id="1" placeholder="Логин" />
                    <input type="text" name="2" id="2" placeholder="Пароль" />
                    <span className={classes.forgetPass}>Забыли пароль?</span>
                    <Link to="/Products"><Button title="Войти" /></Link>
                </div>
            ) : (
                <div className={classes.loginBox}>
                    <p style={{color: "#ba0000"}}><b>Регистрация на сайте временно НЕ РАБОТАЕТ</b></p>
                    <input type="text" name="1" id="1" placeholder="Почта" />
                    <div className={classes.nameInputs}>
                        <input type="text" name="1" id="1" placeholder="Имя" />
                        <input type="text" name="1" id="1" placeholder="Фамилия" />
                    </div>
                    <input type="text" name="1" id="1" placeholder="Логин" />
                    <input type="text" name="1" id="1" placeholder="Название организации" />
                    <input type="text" name="1" id="1" placeholder="ИНН" />
                    <input type="text" name="1" id="1" placeholder="ОГРН/ОГРНИП" />
                    <input type="text" name="1" id="1" placeholder="Пароль" />
                    <input type="text" name="2" id="2" placeholder="Повторите пароль" />
                    <Link to="/Products"><Button title="Войти" /></Link>
                </div>
            )}
        </div>
    )

}

export default Login